<div class="modal fade pleaseWaitDialog in show"
     bsModal
     #siModal="bs-modal"
     [config]="{backdrop: true, ignoreBackdropClick: true}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="container-fluid">
                <div class="row px-4 modal-header">
                    <div class="{{getHeaderSizeClass('title')}} px-0">
                        <h2 class="modal-title">{{"Catalogs that have changed" | translate}}</h2>
                    </div>
                    <div class="{{getHeaderSizeClass('todo')}} py-1 text-right">
                        <i class="far fa-times close-icon"
                           (click)="cancel()"></i>
                    </div>
                </div>
            </div>
            <div class="modal-body px-4 pb-4 pt-2">
                <h4>{{'Overwrite catalogs?' | translate}}</h4>
                <div class="form-group">
                <li *ngFor="let item of catalogsData">
                    <input type="checkbox" [(ngModel)]="item.overwrite" (change)="item.overwrite=true">{{item.name}}
                </li>
                </div>
                <div class="pt-4 modal-buttons">
                    <primary-text-button (click)="copy()">
                        {{ 'Import' | translate }}
                    </primary-text-button>
                    <cancelary-text-button (click)="cancel()">{{ 'Cancel' | translate }}</cancelary-text-button>
                </div>
            </div>
        </div>
    </div>
</div>

